import { get } from "lodash"
import { rj, useRunRj } from "react-rocketjump"
import rjList, { nextPreviousPaginationAdapter } from "react-rocketjump/plugins/list"
import api from "../api"

const getOrSelect = (context, pathOrFunction) => {
  if (typeof pathOrFunction === "function") {
    return pathOrFunction(context)
  }
  return get(context, pathOrFunction)
}

const ProjectActivityListRj = rj(
  rjList({
    pageSize: 100,
    pagination: nextPreviousPaginationAdapter,
    customPaginationReducer: (prevState, { payload: { data } }) => {
      return {
        ...prevState,
        count: getOrSelect(data, nextPreviousPaginationAdapter.count),
        current: getOrSelect(data, nextPreviousPaginationAdapter.current),
        next: getOrSelect(data, nextPreviousPaginationAdapter.next),
        previous: getOrSelect(data, nextPreviousPaginationAdapter.previous),
        full_count: data.full_count,
      }
    },
  }),
  {
    effectCaller: rj.configured(),
    effect: (wpAuth) => (filters) => {
      return api.auth(wpAuth).get(`/api/activity/`, filters)
    },
    selectors: ({ getPagination }) => ({
      getFullCount: (state) => {
        if (state.root) {
          return get(state, "root.data.pagination.full_count", 0)
        }
        return get(state, "data.pagination.full_count", 0)
      },
    }),
    computed: {
      activities: "getList",
      count: "getCount",
      fullCount: "getFullCount",
      loading: "isPending",
      error: "getError",
      pageCount: "getNumPages",
      hasNext: "hasNext",
      hasPrev: "hasPrev",
    },
    mutations: {
      create: rj.mutation.single({
        effect: (wpAuth) => (data) => {
          return api.auth(wpAuth).post(`/api/activity/`, data)
        },
        updater: (state, result) => {
          return {
            ...state,
            data: {
              ...state.data,
              list: [...state.data.list, result],
            },
          }
        },
      }),
      update: rj.mutation.multi((id) => id, {
        effect: (wpAuth) => (id, data) => {
          return api.auth(wpAuth).patch(`/api/activity/${id}/`, data)
        },
        updater: (state, result) => {
          return {
            ...state,
            data: {
              ...state.data,
              list: state.data.list.map((item) => (item.id !== result.id ? item : result)),
            },
          }
        },
      }),
      remove: rj.mutation.multi((id) => id, {
        effect: (wpAuth) => (id) => {
          return api
            .auth(wpAuth)
            .mapResponse(() => id)
            .delete(`/api/activity/${id}/`)
        },
        updater: (state, deletedId) => {
          return {
            ...state,
            data: {
              ...state.data,
              list: state.data.list.filter((item) => item.id !== deletedId),
            },
          }
        },
      }),
      download: rj.mutation.single({
        effect: (wpAuth) => (params) => {
          return api
            .auth(wpAuth)
            .request({
              responseType: "blob",
            })
            .get(`/api/activity/download`, params)
        },
        updater: (state) => state,
      }),
    },
  }
)

export function useProjectActivityList(params) {
  return useRunRj(ProjectActivityListRj, [params])
}

const ProjectActivityCalendarRj = rj(
  rjList({
    pageSize: 2000,
    pagination: nextPreviousPaginationAdapter,
  }),
  {
    effectCaller: rj.configured(),
    effect: (wpAuth) => (filters) => {
      return api.auth(wpAuth).get(`/api/activity/`, { ...filters, page_size: 2000 })
    },
    computed: {
      activities: "getList",
      count: "getCount",
      loading: "isPending",
      error: "getError",
    },
  }
)

export function useProjectActivityCalendar(params) {
  return useRunRj(ProjectActivityCalendarRj, [params])
}
